import React from "react";

const ErrorPage = () => {
  return (
    <div>
      <h1>Oops! Page Not Found</h1>
      <p>Sorry, the page you're looking for doesn't exist.</p>
    </div>
  );
};

export default ErrorPage;